// extracted by mini-css-extract-plugin
export default {"ChannelEventsPrimaryContainer":"ChannelEvents_ChannelEventsPrimaryContainer__h0-8U"};